import script from "./SearchableSelectMakes.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableSelectMakes.vue?vue&type=script&setup=true&lang=js"

import "./SearchableSelectMakes.vue?vue&type=style&index=0&id=f8f185ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8f185ae"]])

export default __exports__